// extracted by mini-css-extract-plugin
export default {"ContentDefinitionsFooterPagination":"ContentDefinitionsFooter_ContentDefinitionsFooterPagination__fpg2s"};